import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import {
  ProviderAvailability,
  ProviderDayAvailability,
  ProviderTimezoneUpdateResponse,
} from '@models';

@Injectable({
  providedIn: 'root',
})
export class ProviderAvailabilityService extends HttpService<unknown> {
  protected override collectionPath = '/providers/{providerId}';

  getAvailability(
    pathSegments: Record<string, string | number>
  ): Observable<ProviderAvailability> {
    const url = this.buildDynamicUrl(pathSegments);
    return this.http.get<ProviderAvailability>(`${url}/availability`);
  }

  updateAvailability(
    availability: ProviderDayAvailability[],
    pathSegments: Record<string, string | number>,
    applyToProviderWebsite?: boolean
  ): Observable<ProviderAvailability> {
    const url = this.buildDynamicUrl(pathSegments);
    return this.http.put<ProviderAvailability>(`${url}/availability`, {
      days: availability,
      applyToProviderWebsite,
    });
  }

  getProviderTimezone(
    pathSegments: Record<string, string | number>
  ): Observable<ProviderTimezoneUpdateResponse> {
    const url = this.buildDynamicUrl(pathSegments);
    return this.http.get<ProviderTimezoneUpdateResponse>(`${url}/timezone`);
  }

  updateProviderTimezone(
    timeZoneId: string,
    pathSegments: Record<string, string | number>
  ): Observable<ProviderTimezoneUpdateResponse> {
    const url = this.buildDynamicUrl(pathSegments);
    return this.http.put<ProviderTimezoneUpdateResponse>(`${url}/timezone`, {
      timeZoneId,
    });
  }
}
